<template>
    <div id="intervention">
        <nav>
            <div class="leftNav">
                <div class="innerNav">
                    <img class="navLogout" v-on:click="logout()" src="/assets/logout.png" alt="logout" />
                </div>
            </div>
            <center>
                <img class="main" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
            <div class="rightNav">
                <div class="innerNav">
                    <span class="pNav">
                        {{Name}}
                    </span>
                    <img class="logoNav" src="/assets/adpr.png" alt="ADPR" />
                </div>
            </div>
        </nav>
        <div class="filAriane">
            <span v-html="filAriane"></span>
        </div>
        <div class="outercircle">
            <div class="homeName">
                {{Name}}
            </div>
            <div id="circle"></div>
        </div>
        <h1>
            <button v-on:click="backbtn()" class="btnBack">
                <font-awesome-icon icon="arrow-alt-circle-left" />
            </button>
            {{intervention.name}} &nbsp;&nbsp;-&nbsp;&nbsp; {{intervention.status}}
        </h1>
        <div class="greyBack">
            <div>
                <p><b>Type d'intervention&nbsp;&nbsp;:&nbsp;&nbsp;{{intervention.type}}</b></p>
                <p><b>Status de l'intervention&nbsp;&nbsp;:&nbsp;&nbsp;{{intervention.status}}</b></p>
                <p><b>Commentaire&nbsp;&nbsp;:</b>&nbsp;&nbsp;{{intervention.note}}</p>
                <p><b>Durée de l'intervention&nbsp;&nbsp;:&nbsp;&nbsp;{{heure}}</b></p>
                <p><b>Date (jj/mm/aa)&nbsp;&nbsp;:&nbsp;&nbsp;{{date}}</b></p>
                <p><b>Technicien de chantier référant&nbsp;&nbsp;:&nbsp;&nbsp;{{MainTech}}</b></p>
                <p v-if="Techs.length === 1" ><b>Technicien&nbsp;&nbsp;:&nbsp;&nbsp;{{Techs[0]}}</b></p>
                <p v-if="Techs.length > 1" >
                    <b>
                        Techniciens&nbsp;&nbsp;:&nbsp;&nbsp;
                    </b>
                    <b v-for="(item, index) in Techs" :key="index">
                        <span v-if="index===0">{{item}}</span>
                        <span v-else="">, &nbsp;&nbsp;{{item}}</span>
                    </b>
                </p>
            </div>
        </div>
        <div class="divCard">
            <span class="spanCardtitle">
            Voir les documents associés
            </span>
            <span class="spanCardtype">
                <i>{{nbDoc}} fichiers</i>
            </span>
            <button v-on:click="goToInterventiondetailPage()" class="btnCard"><font-awesome-icon icon="chevron-right" /></button>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'Intervention',
        data() {
            return {
                intervention : {},
                Name:"client",
                MainTech:"",
                nbDoc:0,
                Techs:[],
                date: "01/01/2019",
                heure: "09:00 - 12:00",
                filAriane: ""
            };
        },
        methods:{
            logout() {
                this.$cookie.delete('jwt');
                this.$cookie.delete('role');
                this.$cookie.delete('firstName');
                this.$cookie.delete('lastName');
                this.$cookie.delete('currentAriane');
                this.$cookie.delete('fromQuery');
                this.$cookie.delete('fromPage');
                this.$cookie.delete('fromPagePrev');
                this.$cookie.delete('fromQueryPrev');
                this.$router.replace({ name: "login" });
            },
            reload() {
                this.$cookie.set('currentAriane', "");
                this.$router.replace({ name: "home" });
            },
            backbtn(){
                this.$cookie.set('currentAriane', this.$cookie.get('currentAriane').substr(0, this.$cookie.get('currentAriane').indexOf("Intervention")-33));
                if(this.$cookie.get('fromQuery') !== ""){
                    this.$router.replace({ name: this.$cookie.get('fromPage'), query: {name: this.$cookie.get('fromQuery')} });
                }
                else{
                    this.$router.replace({ name: this.$cookie.get('fromPage') });
                }
            },
            getCookies: function() {
                if(!this.$cookie.get('jwt') || !this.$cookie.get('role') || this.$cookie.get('role') !== "client" || !this.$route.query.name){
                    this.logout();
                }
                else{
                    this.Name = this.$cookie.get('firstName') +" "+this.$cookie.get('lastName');
                    this.getIntervention();
                }
            },
            getDateOfIntervention(timestamp){
                var n = new Date(timestamp*1000);
                var y = n.getFullYear();
                var day = "0" + n.getDate();
                var month = "0" + (n.getMonth() + 1);
                return  day.substr(-2) + '/' + month.substr(-2) + '/' +y;                            
            },
            getHourOfIntervention(timestamp){
                var n = new Date(timestamp*1000);
                var hours =  "0" +n.getHours();
                var minutes = "0" + n.getMinutes();
                return  hours.substr(-2) + 'h' + minutes.substr(-2);                            
            },
            goToInterventiondetailPage(){
                this.$router.replace({ name: "interventiondetail", query: {name: this.$route.query.name}});
            },
            async getUserData(){
                var response;
                for(var i=0; i<this.intervention.planning.length; i++){
                    if(this.intervention.planning[i].isMain){
                        response = await axios.get('https://so.gaviota.fr/api/userdata/'+ this.intervention.planning[i].user.idWeweb);
                        this.MainTech = response.data.user.address.firstName+" "+response.data.user.address.lastName;
                    }
                    else{
                        response = await axios.get('https://so.gaviota.fr/api/userdata/'+ this.intervention.planning[i].user.idWeweb);
                        this.Techs.push(response.data.user.address.firstName+" "+response.data.user.address.lastName);
                    }
                }
                
            },
            async getIntervention(){
                axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
                var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/intervention/light/'+this.$route.query.name);
                if(response.data.intervention){
                    this.intervention = response.data.intervention;
                    this.date = this.getDateOfIntervention(this.intervention.planning[0].startTimestamp);
                    this.heure = this.getHourOfIntervention(this.intervention.planning[0].startTimestamp) + " - "+this.getHourOfIntervention(this.intervention.planning[0].endTimestamp);
                   
                    this.getUserData();

                    this.nbDoc = this.intervention.picture.length;
                    if(this.intervention.sketch){
                        this.nbDoc = this.nbDoc+1;
                    }
                    if(this.intervention.noticeFiled){
                        this.nbDoc = this.nbDoc+1;
                    }
                    if(this.intervention.intervention){
                        this.nbDoc = this.nbDoc+1;
                    }
                
                    if(this.$cookie.get('currentAriane').indexOf("Intervention") > -1){
                        this.$cookie.set('currentAriane', this.$cookie.get('currentAriane').substr(0, this.$cookie.get('currentAriane').indexOf("Intervention")-33));
                        this.$cookie.set('currentAriane', this.$cookie.get('currentAriane')+"&nbsp;&nbsp;<b>></b>&nbsp;&nbsp;"+" Intervention "+this.intervention.name +"&nbsp;&nbsp;-&nbsp;&nbsp;"+this.intervention.type );
                    }
                    else{
                        this.$cookie.set('currentAriane', this.$cookie.get('currentAriane')+"&nbsp;&nbsp;<b>></b>&nbsp;&nbsp;"+" Intervention "+this.intervention.name +"&nbsp;&nbsp;-&nbsp;&nbsp;"+this.intervention.type );
                    }

                    this.filAriane = this.$cookie.get('currentAriane');
                }
            }
        },
        mounted(){
            this.getCookies();
        }
    }
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=BenchNine');
    #intervention {
        width: 90%;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 60px;
        margin-bottom: 30px;
        border:none;
    }
    h1{
        background-color: #1ce83e;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        padding-bottom:15px;
        padding-top:15px;
        margin:0;
        font-size: 30px;
        font-weight: 600;
        display: block;
        text-align: center;
        position:relative;
    }
    @media screen and (max-width: 768px) {
        .h1 {
              font-size: 24px;
            }
    }
    nav{
        top:0px;
        left:0px;
        right:0px;
        margin: 0px;
        position:fixed;
        z-index:1;
        width:100%;
        background-color: white;
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    .main{
        display: inline-block; 
        cursor: pointer;
        margin:5px;
    }

    .rightNav {
        position:absolute;
        top:0;
        right:0;
    }
    .innerNav {
        display: inline-block;
        position: relative;
    }

    .logoNav{
        vertical-align: middle;
        margin:5px;    
    }
    .navLogout{
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
        margin:24px;
    }
    .leftNav{
        position:absolute;
        top:0;
        left:0;
    }   
    .pNav {
        display:inline-block;
        padding-right:15px;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        vertical-align: middle;
    }
    @media screen and (max-width: 768px) {
        .pNav {
              display: none;
            }
    }
    .homeName{
        margin:auto;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        text-align: center;
        margin:10px;
    }
    .outercircle{
        background-color: #F0F0F0;
        padding:50px;
    }
    #circle {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #1ce83e;
        margin:auto;
    }
    .outermargin{
        background-color: #F0F0F0;
        padding:15px;
    }
    .logout{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 400;
        font-size: 20px;
        display: block;
        border:none;
        margin: auto;
        width: 250px;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
    }
   .btnBack{
        border:none;
        cursor: pointer;
        display: inline-block;
        text-align: left;
        background-color: #1ce83e;
        font-size: 30px;
        position: absolute;
        left: 1%;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .greyBack{
        margin:40px;
        background-color: #E5E5E5;
        color:black;
        font-family: 'BenchNine', sans-serif;
        font-size: 18px;
        padding: 10px;
        border: 1px solid;
        border-color:#555;
    }
    .divCard{
        vertical-align: middle;
        position: relative;
        padding-left: 15px;
        padding-bottom: 25px;
        padding-top: 10px;
        border-bottom: 2px solid;
        border-color:#00000017;
    }
    .spanCardtype{
        display:inline-block;
        font-family: 'BenchNine', sans-serif;
        vertical-align: middle;
        font-size: 15px;
        position: absolute;
        left: 16px;
    }
    .spanCardstatus{
        display:inline-block;
        font-family: 'BenchNine', sans-serif;
        vertical-align: middle;
        font-size: 16px;
        position: absolute;
        right: 55px;
    }
    .spanCardtitle{
        display:block;
        font-family: 'BenchNine', sans-serif;
        font-size: 18px;
        font-weight: 700;
    }
    .btnCard{
        width:20px;
        height: 20px;
        border-radius: 50%;
        font-stretch: ultra-condensed;
        font-size: 15px;
        border:none;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        display:inline-block;
        position: absolute;
        top: 50%;
        right: 20px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .filAriane{
        background-color: #F0F0F0;
        font-family: 'BenchNine', sans-serif;
        padding-top:20px;
        margin-left:-50px;
        margin-bottom:-17px;
        font-size: 17px;
    }
</style>